/**
 * Ein Tab, der VERBORGEN laedt, bekommt keinen Auftritt (G5, 2026-10-14).
 *
 * Jede Auftrittsregel beginnt bei `opacity: 0` (`globals.css`, `.jw-auftritt`/`.jw-aufbau`
 * u. a.). Ein verborgener Tab zeichnet keine Bilder, die Animation bleibt „pending" mit
 * Haltezeit 0 — und zeigt genau diesen Anfangszustand, bis jemand hinsieht. Eine Erweiterung,
 * die die Seite im Hintergrund liest, fand so nur die Ueberschrift.
 *
 * Laedt das Dokument verborgen, setzt dieses Skript die Marke an `<html>`; `globals.css`
 * schaltet darunter jede Animation ab, jedes Element steht in seiner Ruhelage. Beim ersten
 * Sichtbarwerden faellt die Marke, und der Auftritt laeuft vor den Augen des Menschen — die
 * Choreografie eines sichtbar geladenen Tabs bleibt unberuehrt.
 *
 * Vor dem Inhalt ausgegeben (ThemeProvider), sonst waere das erste Bild schon gezeichnet.
 */
export const OHNE_AUFTRITT_MARKE = "data-jw-ohne-auftritt";

export function auftrittVorpaintSkript(): string {
  return (
    `try{var d=document,h=d.documentElement;if(d.visibilityState!=="visible"){h.setAttribute("${OHNE_AUFTRITT_MARKE}","");` +
    `var f=function(){if(d.visibilityState==="visible"){h.removeAttribute("${OHNE_AUFTRITT_MARKE}");d.removeEventListener("visibilitychange",f)}};` +
    `d.addEventListener("visibilitychange",f)}}catch(e){}`
  );
}
